<template>
  <div>
    <usernav></usernav>
    <el-col>
      <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <div class="G-title">
          <span>我的收藏</span>
        </div>
      </el-card>
      <div v-if="loading" class="C-PageLoading">
        <div class="Spinner spinner-grow text-primary"></div>
      </div>
      <information v-if="!loading" :page="true" :pageNum="page" :data="data" :total="total"></information>
    </el-col>
  </div>
</template>

<script>
import Usernav from '@/components/base/header/usernav'
import Information from '@/components/widget/information'
import {request} from '../../network/request'
export default {
  name: 'myfavorite',
  components: {Usernav, Information},
  data () {
    return {
      type: '5',
      total: 0,
      page: 1,
      data: {},
      loading: true
    }
  },
  watch: {
    '$route.query.page': {
      handler (newVal) {
        if (this.$route.query.page) {
          this.page = this.$route.query.page
          this.getdata()
        } else {
          this.page = 1
          this.getdata()
        }
      },
      immediate: true
    }
  },
  methods: {
    getdata () {
      let data = new URLSearchParams()
      data.append('sort', this.type)
      data.append('cid', 'all')
      data.append('page', this.page)
      request({
        url: '/api/lists',
        method: 'post',
        data: data
      }).then(res => {
        this.data = res.data.data
        this.total = res.data.count
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
.G-title{
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/user/myfavorite.vue